import React, { useState } from "react";
import "./faq.css"; // optional styling
import { Helmet } from "react-helmet";

const faqData = [
    {
        id: 1,
        question: "What is the price of a Solar Pump Controller in India?",
        answer:
            "Solar pump controller prices vary based on the HP rating (3HP, 5HP, 7.5HP, or 10HP). At SEA, we offer high-efficiency controllers designed for Indian farming conditions. For a custom quote, please fill out our inquiry form.",
    },
    {
        id: 2,
        question:
            "Can I use an SEA Solar Controller with my existing AC/DC water pump?",
        answer:
            "Yes. Our controllers are designed to be compatible with most existing submersible and surface pumps, allowing you to convert your traditional setup into a solar-powered system easily.",
    },
    {
        id: 3,
        question:
            "Are your solar products eligible for the PM-KUSUM scheme subsidy?",
        answer:
            "Our products are designed to meet the technical standards required for government projects. While we provide the hardware, we recommend checking with your local DISCOM or state renewable energy agency for specific PM-KUSUM subsidy applications.",
    },
    {
        id: 4,
        question: "What is the power range of SEA Solar Pump Controllers?",
        answer:
            "SEA offers controllers ranging from 1 HP to 10 HP. They are compatible with various pump types, including submersible, surface (monoblock), and open-well pumps.",
    },
    {
        id: 5,
        question: "Can I use these controllers with existing electric pumps?",
        answer:
            "Yes. sandip electronics  provides Hybrid Solar Pump Controllers that can work with both solar power and the electrical grid (or a generator) to ensure continuous operation even during cloudy days.",
    },
    {
        id: 6,
        question: "What are the key safety features built into the controller?",
        answer:
            "Key safety features include: 1) Dry Run Protection to stop the pump if the water source is empty, 2) Over/Under Voltage Protection to handle solar panel voltage fluctuations, and 3) Tank Full/Low Water logic using sensors (TH/TC) to automate water level control.",
    },
    {
        id: 7,
        question: "What is ATS(Automatic transfer switch)?",
        answer:
        "An ATS (Automatic Transfer Switch) is an intelligent 'power manager' that allows your pump to run on both solar and grid power. It constantly monitors solar voltage; when sunlight is insufficient, it automatically switches the pump to the electricity grid or a generator without any manual effort. Once the sun returns, it switches back to solar to save you money, ensuring uninterrupted irrigation and complete peace of mind.",
    },
    {
        id: 8,
        question: "Difference between RMS and IoT monitoring?",
        answer:
            "IoT (Internet of Things) is the hardware technology that connects your pump to the internet using sensors and a GSM/GPRS module. RMS (Remote Monitoring System) is the actual software or mobile app where you view this data in a user-friendly way. In simple terms, IoT is the 'bridge' that carries information from the field, while RMS is the 'dashboard' that allows you to monitor performance and remotely control your pump.",
    },
    {
        id: 9,
        question: "Supported pump HP range?",
        answer:
            "At Sandip Electronics and Automation (SEA), we offer a versatile range of solar pump controllers designed to meet various needs, spanning from 1 HP to 10 HP. While our 1 HP to 5 HP models are the most popular for standard agricultural and domestic use, we also provide high-capacity 7.5 HP and 10 HP units for large-scale irrigation and industrial projects. Our controllers are engineered to be compatible with multiple technologies, including PMSM, BLDC, and traditional AC/DC submersible pumps, ensuring high efficiency across all power levels.",
    },
];



const FAQ = () => {
    const [openId, setOpenId] = useState(null);
    const handleToggle = (id) => {
        setOpenId((prev) => (prev === id ? null : id));
    };

    return (
        <>
            <Helmet>
                <title>Solar & IoT FAQs | Expert Support | Sandip electronics  & Automation</title>
                <meta name="description" content="Find answers to common questions about Solar Pump Controllers, G04 Inverters, and IoT Remote Monitoring Systems (RMS). Expert technical advice from SEA engineers." />
                <meta name="keywords" content="solar pump controller faq, iot solar monitoring benefits, sun g04 inverter support, mppt vs pwm controller, solar pump subsidy india, sea customer support" />
                <meta property="og:title" content="SEA Technical FAQ: Everything You Need to Know" />
                <meta property="og:description" content="Have questions about your solar setup? Explore our comprehensive FAQ for answers on installation, IoT, and performance." />
                <meta property="og:url" content="https://official.seaiot.in/faq" />
            </Helmet>
            <div className="faq-page-div">
                <div className="faq-page">
                    <div>
                        <h1 className="faq-title">FAQ</h1>
                    </div>
                    <div className="faq-sec-div">
                        <section className="faq-list">
                            {faqData.map((item) => {
                                const isOpen = openId === item.id;

                                return (
                                    <article key={item.id} className="faq-item">
                                        <button
                                            className="faq-header"
                                            onClick={() => handleToggle(item.id)}
                                        >
                                            <span className="faq-question">{item.question}</span>
                                            <span className="faq-icon">{isOpen ? "-" : "+"}</span>
                                        </button>

                                        {isOpen && (
                                            <div className="faq-body">
                                                <p>{item.answer}</p>
                                            </div>
                                        )}
                                    </article>
                                );
                            })}
                        </section>
                    </div>
                </div>
            </div>
        </>

    );
};

export default FAQ;
